export default __webpack_public_path__ + "5168a42ef4a4f9c23bc095ccd801ef5c.png";